import { render, staticRenderFns } from "./MenuKasa.vue?vue&type=template&id=ea4651be&scoped=true&"
import script from "./MenuKasa.vue?vue&type=script&lang=js&"
export * from "./MenuKasa.vue?vue&type=script&lang=js&"
import style0 from "./MenuKasa.vue?vue&type=style&index=0&id=ea4651be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4651be",
  null
  
)

export default component.exports